import React from 'react';

export default function AlertHexagonIcon({
    size = 19,
    color = '#FF2522',
    strokeWidth = 1,
    opacity = 0.01,
    ...props
}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                opacity={opacity}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.2465 0.46875V18.2465H0.46875V0.46875H18.2465Z"
                stroke={color}
                strokeWidth={strokeWidth}
            />

            <path
                d="M9.35764 6.20945V10.0983M9.35764 12.4687V12.5428M16.0836 11.8909C16.0836 12.7206 15.6391 13.491 14.9206 13.9132L10.5206 16.4539C9.80209 16.8687 8.91318 16.8687 8.18725 16.4539L3.78725 13.9132C3.06873 13.4984 2.62428 12.728 2.62428 11.8909V6.82429C2.62428 5.99466 3.06873 5.22426 3.78725 4.80204L8.18725 2.26131C8.90577 1.84649 9.79468 1.84649 10.5206 2.26131L14.9206 4.80204C15.6391 5.22426 16.0836 5.98726 16.0836 6.82429V11.8909Z"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
